module.exports = __webpack_public_path__ + "img/portugal-liver-cancer-male.c58209fe.png";